import { css } from '@emotion/react';

export const getBannerStyles = (
  variant: 'default' | 'error' | 'success'
) => css`
  background-color: ${variant === 'error'
    ? 'var(--surface-error)'
    : variant === 'success'
    ? 'var(--surface-success)'
    : 'var(--surface-neutral)'};
  border: ${variant === 'error'
    ? '1px solid var(--border-error)'
    : variant === 'success'
    ? '1px solid var(--border-success)'
    : 'none'};
  border-radius: var(--radius-lg);
  padding: var(--spacing-4);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-5);
  min-width: 335px;
`;

export const footerStyles = css`
  display: flex;
  gap: var(--spacing-4);
  align-items: center;
`;

export const actionsStyles = css`
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
`;

export const errorRetryStyles = css`
  display: flex;
  align-items: center;
`;
